import type {ReactNode} from 'react'
import {cn} from '@/lib/utils'

type NumericCellWidth = 'xs' | 'sm' | 'md' | 'lg'
type NumericCellAlign = 'left' | 'center' | 'right'

interface NumericCellProps {
    children: ReactNode
    width?: NumericCellWidth
    align?: NumericCellAlign
    className?: string
    'data-testid'?: string
}

/* eslint-disable i18next/no-literal-string -- CSS class constants */
const widthClasses: Record<NumericCellWidth, string> = {
    xs: 'w-12',
    sm: 'w-16',
    md: 'w-20',
    lg: 'w-24',
}
const alignClasses: Record<NumericCellAlign, string> = {
    left: 'text-left',
    center: 'text-center',
    right: 'text-right',
}
/* eslint-enable i18next/no-literal-string */

/**
 * Fixed-width cell for numeric / compact column content inside rows that are
 * laid out with flex instead of a real `<table>`. Defaults to a small
 * right-aligned cell suitable for counts and durations.
 */
export function NumericCell({
    children,
    width = 'sm',
    align = 'right',
    className,
    'data-testid': testId,
}: NumericCellProps) {
    return (
        <div
            className={cn('shrink-0', widthClasses[width], alignClasses[align], className)}
            data-testid={testId}
        >
            {children}
        </div>
    )
}
